export const routes = {
  home: '/',
  main: '/main',
  favorites: '/favorites',
};
